import { ViewEnsaioAtual } from '@models/views/view-ensaio-atual.model';
import axios from 'axios';
import { ListarEnsaiosPorTipoQueryDto } from '../../../back/src/ensaios/dto/listar-ensaios-por-tipo-query.dto';
import { CancelaEnsaioDto } from '../../../back/src/ensaios/dto/cancela-ensaio-dto';

import { EnsaioAliquotaLogResultados } from '@models/ensaio-aliquota-log-resultados.model';
import { Ensaio } from '@models/ensaio.model';

const listaEnsaiosPorTipo = async (
  queryDto: ListarEnsaiosPorTipoQueryDto,
): Promise<ViewEnsaioAtual[]> => {
  const res = await axios.get<ViewEnsaioAtual[]>('/ensaios/tipo', {
    ...(queryDto ? { params: queryDto } : {}),
  });
  return res.data;
};

const registraResultado = async (
  ensaioId: number,
  formData: FormData,
): Promise<EnsaioAliquotaLogResultados> => {
  const res = await axios.post<EnsaioAliquotaLogResultados>(
    `/ensaios/${ensaioId}/registrar_resultados`,
    formData,
  );
  return res.data;
};

const registraResultadoIcpIcpCobre = async (
  formData: FormData,
): Promise<EnsaioAliquotaLogResultados[]> => {
  const res = await axios.post<EnsaioAliquotaLogResultados[]>(
    '/ensaios/registrar_icp_e_icp_cobre',
    formData,
  );
  return res.data;
};

const cancelaEnsaio = async (
  ensaioId: number,
  formData: CancelaEnsaioDto,
): Promise<Ensaio> => {
  const res = await axios.post<Ensaio>(
    `/ensaios/${ensaioId}/cancelar`,
    formData,
  );
  return res.data;
};

export default {
  listaEnsaiosPorTipo,
  registraResultado,
  registraResultadoIcpIcpCobre,
  cancelaEnsaio,
};
